var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('core-form',{staticStyle:{"height":"100%","overflow":"auto"},attrs:{"col":"1","label-align":"left","label-width":"","editable":true,"label-direction":"vertical"}},[_c('core-form-item',{staticClass:"pad-face"},[_c('modifyFace',{staticStyle:{"width":"100%","max-width":"500px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }